import { render, staticRenderFns } from "./AppletScriptEditor.vue?vue&type=template&id=b0ded620&scoped=true&"
import script from "./AppletScriptEditor.vue?vue&type=script&lang=ts&"
export * from "./AppletScriptEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AppletScriptEditor.vue?vue&type=style&index=0&id=b0ded620&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ded620",
  null
  
)

export default component.exports